import { useBreakpoints } from '@/core/hooks/useBreakpoints/useBreakpoints'
import { FC } from 'react'
import { IconContainer, SideBarContainer } from './sidebar.styles'
import StanceLogo from './components/StanceLogo/StanceLogo'
import SidebarItems from './components/SidebarItems/SidebarItems'
import AtBayLogo from '@assets/images/at-bay.svg?react'
import { useCustomTheme } from '@/core/theme'

type SidebarProps = {
    error?: boolean
    classAddon?: string
    close?: () => void
}

const Sidebar: FC<SidebarProps> = ({
    classAddon = '',
    close,
}: SidebarProps) => {
    const { aboveBreakpoint } = useBreakpoints()
    const theme = useCustomTheme()

    return (
        <SideBarContainer
            className={classAddon}
            data-testid={'sidebar'}
            isLargeScreen={aboveBreakpoint('xl')}
        >
            <StanceLogo
                iconColor={theme.colors.greys[0]}
                textColor={theme.colors.greys[0]}
            />
            <SidebarItems close={close} />
            <IconContainer>
                <AtBayLogo color={theme.colors.greys[0]} />
            </IconContainer>
        </SideBarContainer>
    )
}

export default Sidebar
